
import { Container, ContainerForm, TextFieldStyled } from "./style";
import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import { Link, Redirect } from 'react-router-dom';
import localImage from './SSMA.jpg';
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';
import localImage1 from './segurança.jpeg';
function Ssma() {
  const [backgroundImage, setBackgroundImage] = useState(localImage);
  const [showSidebar, setShowSidebar] = useState(false);
  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }
  const [liClicked, setLiClicked] = useState(false);
  const [liClickedcor, setLiClickedcor] = useState(false);
  const [liClicked1, setLiClicked1] = useState(false);
  const handleCloseSidebar = () => {
    setShowSidebar(false);
    setBackgroundImage(images[0])
  }
  const images = [
    localImage,
    //localImage1,
    //localImage2,
    //localImage3,
    //localImage4,
  ];

  return (<div className="home">


    <div className="banner" style={{ backgroundImage: `url(${localImage})`}} >
      {/* Botao de Menu  */}
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>



      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">

          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>

        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/home" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>MENU</button></Link>
            </li>



            {/* <div className="offcanvas-footer">
              <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
                <Link to="/#" style={{ textDecoration: 'none' }}>
                  <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Sair</button>
                </Link>
              </li>
            </div> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
      <Container>

        {/* Logica da pagina */}

        <div className="green-bar">
          <div className="button-grid" >

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', marginTop: '0%' }}>







              <button className="btn btn-success mt-4 hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}>  <Link to='/app/DashBoardSSMT' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >DashBoard de EPI's</Link></button>


              <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/DashboardPlanoAçao' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Dashboard de Plano de Ação</Link></button>


            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>

              <button className="btn btn-success mt-4 btn-block hover-effect" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}><Link to='/app/PlanodeAçoes' style={{ color: '#ffffff', backgroundColor: '#072421', textDecoration: 'none' }} >Plano de Ações</Link></button>



              <button class="btn btn-secondary mt-4 dropdown-toggle btn-block hover-effect" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" style={{ backgroundColor: '#072421', borderRadius: '100px', width: '40%', height: '50px', fontSize: '20px' }}>Check-lists</button>



              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" style={{ backgroundColor: '#072421', width: '20%', maxHeight: '150px', overflowY: 'auto', overflowX: 'hidden', fontSize: '20px' }}>


                <li className="nav-link">
                  <Link to='/app/ChecklistPipa' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Caminhão Pipa
                  </Link>
                </li>
                <li className="nav-link">
                  <Link to='/app/CheckListCaminhaoPrancha' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Caminhão Prancha
                  </Link>
                </li>


                <li className="nav-link">
                  <Link to='/app/ChecklistDiariaSonda' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Diário de sonda
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistDiariaVeiculos' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Inspeção Diária de Veículos
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistFadiga' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Diário Sobre Fadiga
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistAlojamento' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Alojamento
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistPreCampo' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Pré Campo
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistMeioAmbiente' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Inspeção de Meio Ambiente
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistComponentes' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Componentes e Acessórios
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistFerramentas' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Ferramentas Manuais
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistExtintores' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Extintores
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/ChecklistFogareiro' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Fogareiro
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/KitAmbiental' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Kit-Ambiental
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/PracaSondagem' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Praça de Sondagem
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/InspecaoCampo' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Inspeção de Campo
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/OcorrenciasCampo' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Ocorrências de campo
                  </Link>
                </li>

                <li className="nav-link">
                  <Link to='/app/RelatorioIncidente' className="dropdown-item hover-effect" style={{ color: '#ffffff', backgroundColor: '#072421' }}>
                    Relato de Incidente
                  </Link>
                </li>

              </ul>
            </div>


          </div>


        </div>





      </Container>
    </div>
  </div>





  )
}
export default Ssma;